import axios from "axios";

const allowPingMessages = true;

export const makeUpload = (url, clientId, file, modID, successFn, errorFn) => {
    const client = axios.create();

    let contentType = "";
    let ext = file.name.split(".").pop().toUpperCase();

    /* Check for contentType in TROHTTPFileDispatcher.Process on server. */
    switch (ext) {
        case "CSV":
            contentType = "text/csv";
            break;
        case "XLS":
            contentType = "application/vnd.ms-excel";
            break;
        case "XLSX":
            contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            break;
        case "PJNZ":
            contentType = "application/SPECTRUM_PJNZ_FILE";
            break;
        case "UNZ":
            contentType = "application/UNHCR_UNZ_FILE";
            break;
        case "GTZ":
            contentType = "application/GoalsTesting_GTZ_FILE";
            break;
        case "CIZ":
            contentType = "application/COSTIT_CIZ_FILE";
            break;
        default:
            contentType = "";
    }

    console.log({
        methodName: "makeUpload",
        headers: {
            "Content-Type": contentType,
            SessionGuid: clientId,
            FileTitle: file.name,
            ModID: modID,
        },
        file: file,
    });

    client
        .post(url, file, {
            headers: {
                "Content-Type": contentType,
                SessionGuid: clientId,
                FileTitle: file.name,
                ModID: modID,
            },
        })
        .then((response) => {
            let output = {};
            output.methodName = "makeUpload";
            output.result = response;
            console.log(output);

            successFn();
        })
        .catch((e) => {
            console.log("Error");
            DoError(e, errorFn);
        });
};

export const makeRequest = (url, clientId, method, params, jsonParams, successFn, errorFn) => {
    const client = axios.create({
        baseURL: url,
        headers: {
            "Content-Type": "application/json",
        },
    });

    if (method !== "GBLoginService.Ping" || allowPingMessages) {
        console.log({
            _: "SEND",
            url: url,
            clientId: clientId,
            methodName: method,
            params: {
                ...params,
                jsonMesg: jsonParams,
            },
        });
    }

    client
        .post(url, {
            id: clientId,
            method: method,
            params: {
                ...params,
                jsonMesg: JSON.stringify(jsonParams),
            },
        })
        .then((response) => {
            DoThen(response, successFn, errorFn);
        })
        .catch((e) => {
            DoError(e, errorFn);
        });
};

const DoThen = (response, successFn, errorFn) => {
    let clientID = response.data.id;
    let method = JSON.parse(response.config.data).method;
    let params = JSON.parse(response.config.data).params;
    let result = response.data.result.Result;

    if (result === "undefined") {
        result = undefined;
    } else if (typeof result === "string" && (result.charAt(0) === "{" || result.charAt(0) === "[")) {
        result = JSON.parse(response.data.result.Result);
    } else {
        result = response.data.result.Result;
    }

    let output = {};
    output._ = "GET";
    output.methodName = method;
    output.params = params;
    output.result = result;

    if (method !== "GBLoginService.Ping" || allowPingMessages) {
        console.log(output);
    }

    if (result.status === 1) {
        if (typeof errorFn !== "undefined") {
            try {
                errorFn("The server returned an error: \n" + result.statusText);
            } catch (e) {
                DoError(
                    {
                        message:
                            "An error has occurred on the client side after receiving the server data: \n" + e.message,
                    },
                    errorFn
                );
            }
        } else {
            DoError({ message: "The server returned an error: " + result.statusText }, errorFn);
        }
    } else if (typeof successFn !== "undefined") {
        try {
            if (typeof result.result !== "undefined" && result.result !== null) {
                successFn(result.result, clientID);
            } else {
                successFn(result, clientID);
            }
        } catch (e) {
            DoError(
                { message: "An error has occurred on the client side after receiving the server data: \n" + e.message },
                errorFn
            );
        }
    }
};

const DoError = (e, errorFn) => {
    console.error(e);

    try {
        let message = "";

        // Did not contact the server
        if (typeof e.response === "undefined") {
            switch (e.message) {
                case "Network Error":
                    message = "The server may be unavailable at this time.";
                    break;

                default:
                    message = "An error has occurred with communicating to the server.";
                    break;
            }
        } else {
            // Contacted the server, but the server had an error
            message = "Error returned from the server: \n" + JSON.parse(e.response.request.response).error.message;
        }

        if (typeof errorFn !== "undefined") {
            // Custom error handling
            errorFn(message);
        } else {
            // Generic error handling
            alert(message);
            console.error("Note to client-side programmer: You really should handle this error on the client side.");
        }
    } catch (e) {
        alert("An error has occurred on the client side after handling a server error: \n" + e.message);
    }
};
